import { useTranslation } from 'react-i18next'
import { validatePassword, validatePIN } from '@/lib/validation'

interface ValidationChecklistProps {
  value: string
  type: 'password' | 'pin'
}

export default function ValidationChecklist({ value, type }: ValidationChecklistProps) {
  const { t } = useTranslation()

  if (type === 'password') {
    const validation = validatePassword(value)

    return (
      <ul className="mt-2 space-y-1 text-sm">
        <li className={validation.isLong ? 'text-green-600 font-bold' : 'text-gray-400 font-light'}>
          {t('admin.validation.minLength')}
        </li>
        <li className={validation.hasUpper ? 'text-green-600 font-bold' : 'text-gray-400 font-light'}>
          {t('admin.validation.uppercase')}
        </li>
        <li className={validation.hasSpecial ? 'text-green-600 font-bold' : 'text-gray-400 font-light'}>
          {t('admin.validation.digitOrSpecial')}
        </li>
      </ul>
    )
  }

  if (type === 'pin') {
    const validation = validatePIN(value)

    return (
      <ul className="mt-2 space-y-1 text-sm">
        <li className={validation.isSixDigits ? 'text-green-600 font-bold' : 'text-gray-400 font-light'}>
          {t('admin.validation.pinLength')}
        </li>
        <li className={validation.isNotSimple ? 'text-green-600 font-bold' : 'text-gray-400 font-light'}>
          {t('admin.validation.pinNotSimple')}
        </li>
      </ul>
    )
  }

  return null
}
